import { IconId } from '@drone-js/core';

export enum CategoryId {
    All = 'All',
    TourAndTrip = 'TourAndTrip',
    FoodAndDrinks = 'FoodAndDrinks',
    Attractions = 'Attractions',
    OutdoorActivities = 'OutdoorActivities',
    IndoorActivities = 'IndoorActivities',
    EventExhibitionShow = 'EventExhibitionShow',
    Transportation = 'Transportation',
    HealthAndWellness = 'HealthAndWellness',
    TravelEssentials = 'TravelEssentials',
    ArtDesignCulture = 'ArtDesignCulture',
    Tours = 'Tours',
    SimCardsAndWifi = 'SimCardsAndWifi',
    Experiences = 'Experiences',
    Sales = 'Sales',
}

export const CategoryCms: Record<CategoryId, number> = {
    [CategoryId.All]: 252205,
    [CategoryId.TourAndTrip]: 252194,
    [CategoryId.FoodAndDrinks]: 252195,
    [CategoryId.Attractions]: 252196,
    [CategoryId.OutdoorActivities]: 252197,
    [CategoryId.IndoorActivities]: 252198,
    [CategoryId.EventExhibitionShow]: 252199,
    [CategoryId.Transportation]: 252200,
    [CategoryId.HealthAndWellness]: 252201,
    [CategoryId.TravelEssentials]: 252202,
    [CategoryId.ArtDesignCulture]: 252203,
    [CategoryId.Tours]: 288411,
    [CategoryId.SimCardsAndWifi]: 288412,
    [CategoryId.Experiences]: 288413,
    [CategoryId.Sales]: 366427,
};

export enum CategoryCodes {
    ALL = 'All',
    TOUR_AND_TRIP = 'TourAndTrip',
    FOOD_AND_DRINKS = 'FoodAndDrinks',
    ATTRACTIONS = 'Attractions',
    OUTDOOR_ACTIVITIES = 'OutdoorActivities',
    INDOOR_ACTIVITIES = 'IndoorActivities',
    EVENT_EXHIBITION_SHOW = 'EventExhibitionShow',
    TRANSPORTATION = 'Transportation',
    HEALTH_AND_WELLNESS = 'HealthAndWellness',
    TRAVEL_ESSENTIALS = 'TravelEssentials',
    ART_DESIGN_CULTURE = 'ArtDesignCulture',
    TOURS = 'Tours',
    SIM_CARDS_AND_WIFI = 'SimCardsAndWifi',
    EXPERIENCES = 'Experiences',
    Sales = 'Sales',
}

export const CategoryTabTitleCms: Record<CategoryId, number> = {
    [CategoryId.All]: 252411,
    [CategoryId.EventExhibitionShow]: 252417,
    [CategoryId.IndoorActivities]: 252416,
    [CategoryId.Transportation]: 252418,
    [CategoryId.FoodAndDrinks]: 252413,
    [CategoryId.TravelEssentials]: 252420,
    [CategoryId.ArtDesignCulture]: 252421,
    [CategoryId.HealthAndWellness]: 252419,
    [CategoryId.OutdoorActivities]: 252415,
    [CategoryId.Attractions]: 252414,
    [CategoryId.TourAndTrip]: 252412,
    [CategoryId.Tours]: 288564,
    [CategoryId.SimCardsAndWifi]: 288565,
    [CategoryId.Experiences]: 288566,
    [CategoryId.Sales]: 371306,
};

export interface AssetIcon {
    id: IconId;
    url: string;
}

export const CategoryIcon: Record<CategoryId, AssetIcon> = {
    [CategoryId.All]: { id: 'fill.symbol.square-4', url: '' },
    [CategoryId.EventExhibitionShow]: { id: 'fill.activity.ticket', url: '' },
    [CategoryId.IndoorActivities]: { id: 'fill.activity.bowling', url: '' },
    [CategoryId.Transportation]: { id: 'fill.transportation.car', url: 'category-transportation.svg' },
    [CategoryId.FoodAndDrinks]: { id: 'fill.food.fork-knife', url: 'category-foodndrinks.svg' },
    [CategoryId.TravelEssentials]: { id: 'fill.symbol.doc-checklist', url: 'category-travel-essentials.svg' },
    [CategoryId.ArtDesignCulture]: { id: 'fill.activity.mask', url: '' },
    [CategoryId.HealthAndWellness]: { id: 'fill.activity.yoga', url: '' },
    [CategoryId.OutdoorActivities]: { id: 'fill.activity.forest', url: '' },
    [CategoryId.Attractions]: { id: 'fill.activity.tent', url: 'category-attractions.svg' },
    [CategoryId.TourAndTrip]: { id: 'fill.service.guide', url: '' },
    [CategoryId.Tours]: { id: 'fill.service.guide', url: 'category-day-tour.svg' },
    [CategoryId.SimCardsAndWifi]: { id: 'fill.electrics.wifi', url: 'category-simnwifi.svg' },
    [CategoryId.Experiences]: { id: 'fill.activity.dance', url: 'category-experiences.svg' },
    [CategoryId.Sales]: { id: 'fill.symbol.tag', url: 'category-sales.svg' },
};

export const CategorySubLabelCms: Record<CategoryId, number | null> = {
    [CategoryId.All]: null,
    [CategoryId.TourAndTrip]: null,
    [CategoryId.FoodAndDrinks]: null,
    [CategoryId.Attractions]: null,
    [CategoryId.OutdoorActivities]: null,
    [CategoryId.IndoorActivities]: null,
    [CategoryId.EventExhibitionShow]: null,
    [CategoryId.Transportation]: null,
    [CategoryId.HealthAndWellness]: null,
    [CategoryId.TravelEssentials]: 288410,
    [CategoryId.ArtDesignCulture]: null,
    [CategoryId.Tours]: null,
    [CategoryId.SimCardsAndWifi]: null,
    [CategoryId.Experiences]: null,
    [CategoryId.Sales]: null,
};
